import React, { Component } from 'react';

import removeCircle from 'components/svg/remove-circle.svg';
import PropTypes from 'prop-types';

import TwitterPicker from './TwitterPicker';

import './ColorPick.scss';

class ColorPick extends Component {
  static propTypes = {
    selectedColor: PropTypes.string,
    colors: PropTypes.arrayOf(PropTypes.string),
    changeColor: PropTypes.func,
    resetColorAvailable: PropTypes.bool
  };

  static defaultProps = {
    selectedColor: '',
    colors: [],
    resetColorAvailable: false
  };

  state = {
    displayColorPicker: false,
    color: ''
  };

  componentDidMount() {
    const { selectedColor } = this.props;

    this.setState({ color: selectedColor });
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker });
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false });
  };

  handleChange = (color) => {
    const { changeColor } = this.props;
    const backgroundColorPattern = /url([^a-z0-9])[^a-z0-9]/g;
    const isBackgroundColor = backgroundColorPattern.test(color.hex);
    const emptyColor = '';

    this.setState({ color: color.hex });

    if (!isBackgroundColor) {
      changeColor(color.hex);
    } else {
      changeColor(emptyColor);
    }

    this.handleClose();
  };

  get colorsResult() {
    const { colors, resetColorAvailable } = this.props;
    const resetColorIcon = [`url(${removeCircle}) no-repeat center`];

    return resetColorAvailable ? resetColorIcon.concat(colors) : colors;
  }

  render() {
    const styles = {
      color: {
        background: this.state.color
      }
    };

    const twitterStyles = {
      default: {
        hash: {
          display: 'none'
        },
        input: {
          display: 'none'
        }
      }
    };

    return (
      <div>
        <div className="color__pick" onClick={this.handleClick}>
          <div className="color__pick__internal" style={styles.color} />
          <div className="color__pick__arrow" />
        </div>
        {this.state.displayColorPicker && (
          <div className="color__pick__popover">
            <div className="color__pick__cover" onClick={this.handleClose} />
            <TwitterPicker
              color={this.state.color}
              onChange={this.handleChange}
              styles={twitterStyles}
              colors={this.colorsResult}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ColorPick;
